// extracted by mini-css-extract-plugin
module.exports = {"container":"summary_container__31_L3","firstSubtitle":"summary_firstSubtitle__18i0J","subtitle":"summary_subtitle__vzbod"};